import React, { useState, useRef } from "react";
import "../assets/css/menubar.css"
import { Modal } from "react-bootstrap";
import menuLogo from "../assets/images/logo.png";
import menuLanguage from "../assets/images/language.png";
import menuSearch from "../assets/images/search.png";
import EN_flag from "../assets/images/EN-flag.png";
import AR_flag from "../assets/images/AR-flag.png";
import CN_flag from "../assets/images/CH-flag.png";
import DE_flag from "../assets/images/DE-flag.png";
import ID_flag from "../assets/images/ID-flag.png";
import JP_flag from "../assets/images/JP-flag.png";
import KH_flag from "../assets/images/KH-flag.png";
import MY_flag from "../assets/images/MY-flag.png";
import NL_flag from "../assets/images/NL-flag.png";
import PH_flag from "../assets/images/PH-flag.png";
import SK_flag from "../assets/images/SK-flag.png";
import TH_flag from "../assets/images/TH-flag.png";
import VN_flag from "../assets/images/VN-flag.png";
import down_arrow from "../assets/images/down_arrow.png";

const Menubar = () => {
  const [isSearchFocused, setIsSearchFocused] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const searchRef = useRef(null);

  const lang_item = [
    { id: 1, lang: 'EN', flag: EN_flag },
    { id: 2, lang: 'AR', flag: AR_flag },
    { id: 3, lang: 'CN', flag: CN_flag },
    { id: 4, lang: 'DE', flag: DE_flag },
    { id: 5, lang: 'ID', flag: ID_flag },
    { id: 6, lang: 'JP', flag: JP_flag },
    { id: 7, lang: 'KH', flag: KH_flag },
    { id: 8, lang: 'MY', flag: MY_flag },
    { id: 9, lang: 'NL', flag: NL_flag },
    { id: 10, lang: 'PH', flag: PH_flag },
    { id: 11, lang: 'SK', flag: SK_flag },
    { id: 12, lang: 'TH', flag: TH_flag },
    { id: 13, lang: 'VN', flag: VN_flag },
  ];


  // This will hide the search bar when clicking outside the search area
  const handleClickOutside = (event) => {
    if (searchRef.current && !searchRef.current.contains(event.target)) {
      setIsSearchFocused(false); // Hide search bar when clicking outside
    }
  };

  // Adding event listener for click outside
  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLanguageChange = (event) => {
    setSelectedLanguage(event.target.textContent);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    // Perform search actions here
  };

  const handleSearchButtonClick = () => {
    setIsModalVisible(true); // Show modal when the search button is clicked
  };

  const handleCloseModal = () => {
    setIsModalVisible(false); // Close modal
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light px-4 py-3">
      <div className="container-fluid">
        {/* Logo */}
        <a className="navbar-brand" href="/#">
          <div
            className="d-flex logo justify-content-center align-items-center"
            style={{ fontSize: "28px" }}
          >
            <img
              src={menuLogo}
              alt="Logo"
              style={{ width: "24px", height: "24px" }}
            />
            <span className="mx-1">ST</span>
            <span>INFINITY</span>
          </div>
          <div
            className="fw-light"
            style={{ fontSize: "13px", letterSpacing: "2px" }}
          >
            <span>Identity-First Platforms</span>
          </div>
        </a>

        {/* Responsive Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div
          className="collapse navbar-collapse"
          id="navbarContent"
          style={{ fontSize: "18px", fontFamily: "Helvetica Neue" }}
        >
          <ul className="navbar-nav ms-auto align-items-center">
            {/* Links with Dropdowns */}
            <li className="nav-item dropdown me-4">
              <a
                className="nav-link dropdown-toggle"
                href="/#"
                id="platformDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="menu_btn">Platforms</span>
                <img
                  src={down_arrow}
                  alt="down_arrow"
                  className="down_arrow"
                ></img>
              </a>
              <ul
                className="dropdown-menu custom-dropdown"
                aria-labelledby="platformDropdown"
              >
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Cloud Platform
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Hybrid Platform
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    On Premises
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown me-4">
              <a
                className="nav-link dropdown-toggle"
                href="/#"
                id="solutionsDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="menu_btn">Solutions</span>
                <img
                  src={down_arrow}
                  alt="down_arrow"
                  className="down_arrow"
                ></img>
              </a>
              <ul
                className="dropdown-menu custom-dropdown"
                aria-labelledby="solutionsDropdown"
              >
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Penetration Testing
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Managed Risk
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Managed Security Jouney
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Incident Response
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    DevSecOps
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Vulnerability Management
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Hybrid Detection and Response
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Hybrid Security Posture Management
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Managed Security Services
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Threat Hunting
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Compliance
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Incident Response
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    SOC
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item dropdown me-4">
              <a
                className="nav-link dropdown-toggle"
                href="/#"
                id="ostInfinityDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="menu_btn">Ost Infinity</span>
                <img
                  src={down_arrow}
                  alt="down_arrow"
                  className="down_arrow"
                ></img>
              </a>
              <ul
                className="dropdown-menu custom-dropdown"
                aria-labelledby="ostInfinityDropdown"
              >
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    About Us
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Meet Your Experts
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Case Studies
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item me-4">
              <a className="nav-link" href="/#">
                <span className="menu_btn">Blog</span>
              </a>
            </li>
            <li className="nav-item dropdown me-4">
              <a
                className="nav-link dropdown-toggle"
                href="/#"
                id="blogDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="menu_btn">Global Reach</span>
                <img
                  src={down_arrow}
                  alt="down_arrow"
                  className="down_arrow"
                ></img>
              </a>
              <ul
                className="dropdown-menu custom-dropdown"
                aria-labelledby="globalReachDropdown"
              >
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Partners
                  </a>
                </li>
                <li>
                  <a className="dropdown-item custom-dropdown-item" href="/#">
                    Clients
                  </a>
                </li>
              </ul>
            </li>
            <li className="nav-item me-4">
              <a
                className="nav-link"
                href="/#"
                style={{
                  outline: "2px solid #F98D11",
                  borderRadius: "5px",
                  padding: "5px 10px",
                }}
              >
                <span className="menu_btn">Talk to an IR Advisor</span>
              </a>
            </li>
            {/* Language Selector */}
            <li className="nav-item dropdown me-4">
              <a
                className="nav-link dropdown-toggle d-flex align-items-center"
                href="/#"
                id="languageDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {/* Language label */}
                <img src={menuLanguage} alt="menuLanguage" />

                {/* Display selected language between label and dropdown icon */}
                {selectedLanguage && (
                  <span className="ms-2 text-white" style={{ width: "30px" }}>
                    {selectedLanguage}
                  </span>
                )}

                {/* Dropdown icon */}
                <span className="ms-2">
                  <i className="bi bi-chevron-down"></i>
                </span>
              </a>

              <ul
                className="dropdown-menu custom-dropdown"
                aria-labelledby="languageDropdown"
              >
                {lang_item.map((item, index) => (
                  <li>
                    <a
                      className="dropdown-item custom-dropdown-item"
                      href="/#"
                      onClick={handleLanguageChange}
                    >
                      <img src={item.flag} alt="flag" className="me-3"></img>
                      <span>{item.lang}</span>
                    </a>
                  </li>
                ))}
                {/* <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={AR_flag} alt="AR_flag" className="me-3"></img>
                    <span>AR</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={CN_flag} alt="CN_flag" className="me-3"></img>
                    <span>CN</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={DE_flag} alt="DE_flag" className="me-3"></img>
                    <span>DE</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={ID_flag} alt="ID_flag" className="me-3"></img>
                    <span>ID</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={JP_flag} alt="JP_flag" className="me-3"></img>
                    <span>JP</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={KH_flag} alt="KH_flag" className="me-3"></img>
                    <span>KH</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={MY_flag} alt="MY_flag" className="me-3"></img>
                    <span>MY</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={NL_flag} alt="NL_flag" className="me-3"></img>
                    <span>NL</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={PH_flag} alt="PH_flag" className="me-3"></img>
                    <span>PH</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={SK_flag} alt="SK_flag" className="me-3"></img>
                    <span>SK</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={TH_flag} alt="TH_flag" className="me-3"></img>
                    <span>TH</span>
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item custom-dropdown-item"
                    href="/#"
                    onClick={handleLanguageChange}
                  >
                    <img src={VN_flag} alt="VN_flag" className="me-3"></img>
                    <span>VN</span>
                  </a>
                </li> */}
              </ul>
            </li>
            {/* Search Bar */}
            <li className="nav-item">
              <form
                className="d-flex"
                ref={searchRef}
                onSubmit={handleSearchSubmit}
              >
                <div
                  className={`input-group ${isSearchFocused ? "d-flex" : "d-none"
                    }`}
                  style={{
                    transition:
                      "opacity 0.3s ease-in-out, visibility 0s linear 0.3s",
                    opacity: isSearchFocused ? 1 : 0,
                    visibility: isSearchFocused ? "visible" : "hidden",
                  }}
                >
                  <input
                    className="form-control me-4"
                    type="search"
                    placeholder="Search"
                    aria-label="Search"
                    onBlur={() => setIsSearchFocused(false)}
                    onFocus={() => setIsSearchFocused(true)}
                  />
                  <button className="btn btn-outline-success" type="submit">
                    Search
                  </button>
                </div>

                <div
                  className={`search-icon ${isSearchFocused ? "d-none" : ""}`}
                  onClick={handleSearchButtonClick} // Show modal on icon click
                >
                  <img src={menuSearch} alt="Search" />
                </div>
              </form>

              {/* Modal for search */}
              <Modal show={isModalVisible} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                  <Modal.Title>Search</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <form onSubmit={handleSearchSubmit}>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="search"
                        placeholder="Search"
                        aria-label="Search"
                      />
                      <button className="btn btn-outline-success" type="submit">
                        Search
                      </button>
                    </div>
                  </form>
                </Modal.Body>
              </Modal>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Menubar;

// import React from 'react';
// import "../assets/css/navbar.css";
// import Button from 'react-bootstrap/Button';
// import Container from 'react-bootstrap/Container';
// import Form from 'react-bootstrap/Form';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import NavDropdown from 'react-bootstrap/NavDropdown';
// import menuLogo from "../assets/images/logo.png";
// import menuLanguage from "../assets/images/language.png";
// import menuSearch from "../assets/images/search.png";
// import EN_flag from "../assets/images/EN-flag.png";
// import AR_flag from "../assets/images/AR-flag.png";
// import CN_flag from "../assets/images/CH-flag.png";
// import DE_flag from "../assets/images/DE-flag.png";
// import ID_flag from "../assets/images/ID-flag.png";
// import JP_flag from "../assets/images/JP-flag.png";
// import KH_flag from "../assets/images/KH-flag.png";
// import MY_flag from "../assets/images/MY-flag.png";
// import NL_flag from "../assets/images/NL-flag.png";
// import PH_flag from "../assets/images/PH-flag.png";
// import SK_flag from "../assets/images/SK-flag.png";
// import TH_flag from "../assets/images/TH-flag.png";
// import VN_flag from "../assets/images/VN-flag.png";

// const lang_item = [
//   { id: 1, lang: 'EN', flag: EN_flag },
//   { id: 2, lang: 'AR', flag: AR_flag },
//   { id: 3, lang: 'CN', flag: CN_flag },
//   { id: 4, lang: 'DE', flag: DE_flag },
//   { id: 5, lang: 'ID', flag: ID_flag },
//   { id: 6, lang: 'JP', flag: JP_flag },
//   { id: 7, lang: 'KH', flag: KH_flag },
//   { id: 8, lang: 'MY', flag: MY_flag },
//   { id: 9, lang: 'NL', flag: NL_flag },
//   { id: 10, lang: 'PH', flag: PH_flag },
//   { id: 11, lang: 'SK', flag: SK_flag },
//   { id: 12, lang: 'TH', flag: TH_flag },
//   { id: 13, lang: 'VN', flag: VN_flag },
// ];


// const Menubar = () => {
//   return (
//     <Navbar expand="lg" className="bg-body-tertiary navbar-background">
//       <Container fluid>
//         <Navbar.Brand href="#">
//           <div
//             className="d-flex logo justify-content-center align-items-center"
//             style={{ fontSize: "28px", color: "white"}}
//           >
//             <img
//               src={menuLogo}
//               alt="Logo"
//               style={{ width: "24px", height: "24px" }}
//             />
//             <span className="mx-1">ST</span>
//             <span>INFINITY</span>
//           </div>
//           <div
//             className="fw-light"
//             style={{ fontSize: "13px", letterSpacing: "2px", color: 'white' }}
//           >
//             <span>Identity-First Platforms</span>
//           </div>
//         </Navbar.Brand>
//         <Navbar.Toggle aria-controls="navbarScroll" />
//         <Navbar.Collapse id="navbarScroll">
//           <Nav className="me-auto my-2 my-lg-0">
//             <Nav.Link href="#action1">Home</Nav.Link>
//             <Nav.Link href="#action2">Link</Nav.Link>
//             <NavDropdown title="Link" id="navbarScrollingDropdown">
//               <NavDropdown.Item href="#action3">Action</NavDropdown.Item>
//               <NavDropdown.Item href="#action4">
//                 Another action
//               </NavDropdown.Item>
//               <NavDropdown.Divider />
//               <NavDropdown.Item href="#action5">
//                 Something else here
//               </NavDropdown.Item>
//             </NavDropdown>
//             <Nav.Link href="#" disabled>
//               Link
//             </Nav.Link>
//           </Nav>
//           <Form className="d-flex">
//             <Form.Control
//               type="search"
//               placeholder="Search"
//               className="me-2"
//               aria-label="Search"
//             />
//             <Button variant="outline-success">Search</Button>
//           </Form>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }

// export default Menubar;
